import { NodePaletteItem, NodeCategory } from '../types/flows';

export const categoryColors: Record<NodeCategory, string> = {
  ingestion: '#10b981',    // emerald
  processing: '#f59e0b',   // amber
  analysis: '#3b82f6',     // blue
  visualization: '#a855f7', // purple
  output: '#f97316',       // orange
};

export const nodePaletteItems: NodePaletteItem[] = [
  // --- Data Ingestion ---
  {
    type: 'upload-data',
    label: 'Upload Data',
    description: 'CSV, Excel, JSON, Parquet, TSV',
    icon: 'FileSpreadsheet',
    category: 'ingestion',
    width: 300,
  },
  {
    type: 'upload-media',
    label: 'Upload Media',
    description: 'Audio, video & image files',
    icon: 'Headphones',
    category: 'ingestion',
    width: 300,
  },
  {
    type: 'upload-pdf',
    label: 'Upload PDF',
    description: 'PDF documents',
    icon: 'FileText',
    category: 'ingestion',
    width: 300,
  },
  {
    type: 'url-download',
    label: 'URL Download',
    description: 'Download file from URL',
    icon: 'Link',
    category: 'ingestion',
    width: 300,
  },
  {
    type: 'cloud-transfer',
    label: 'Cloud Transfer',
    description: 'Import from AWS S3 or GCP',
    icon: 'Cloud',
    category: 'ingestion',
    width: 340,
  },
  {
    type: 'sql-import',
    label: 'SQL Import',
    description: 'Import from SQL database',
    icon: 'Database',
    category: 'ingestion',
    width: 340,
  },
  {
    type: 'file-picker',
    label: 'File Picker',
    description: 'Select existing dataset',
    icon: 'FolderOpen',
    category: 'ingestion',
    width: 300,
  },

  // --- Analysis ---
  {
    type: 'filter',
    label: 'Filter',
    description: 'Column-level filtering',
    icon: 'SlidersHorizontal',
    category: 'analysis',
    width: 350,
  },
  {
    type: 'search',
    label: 'Search',
    description: 'Search & filter columns',
    icon: 'Search',
    category: 'analysis',
    width: 350,
  },
  {
    type: 'query',
    label: 'Query',
    description: 'Run Polars or AI queries',
    icon: 'Code',
    category: 'analysis',
    width: 400,
  },
  {
    type: 'chat',
    label: 'Chat',
    description: 'Natural language data Q&A',
    icon: 'MessageSquare',
    category: 'analysis',
    width: 350,
  },

  // --- Visualization ---
  {
    type: 'visualize',
    label: 'Visualize',
    description: '3D data visualization',
    icon: 'Box',
    category: 'visualization',
    width: 320,
  },

  // --- Output ---
  {
    type: 'export',
    label: 'Export',
    description: 'Download as CSV or JSON',
    icon: 'FileDown',
    category: 'output',
    width: 320,
  },
  {
    type: 'api-endpoint',
    label: 'API Endpoint',
    description: 'REST API access & key',
    icon: 'Code2',
    category: 'output',
    width: 400,
  },
  {
    type: 'mcp',
    label: 'MCP Server',
    description: 'Claude Desktop config',
    icon: 'Plug',
    category: 'output',
    width: 400,
  },
  {
    type: 'zapier',
    label: 'Zapier',
    description: 'Zapier API key & webhooks',
    icon: 'Zap',
    category: 'output',
    width: 350,
  },
];

export const categoryLabels: Record<NodeCategory, string> = {
  ingestion: 'Data Ingestion',
  processing: 'Processing',
  analysis: 'Analysis',
  visualization: 'Visualization',
  output: 'Output',
};

export const categoryOrder: NodeCategory[] = [
  'ingestion',
  'analysis',
  'visualization',
  'output',
];

// Maps every node type (including template-only aliases) to its category
export const nodeTypeToCategory: Record<string, NodeCategory> = {
  'upload': 'ingestion',
  'upload-data': 'ingestion',
  'upload-media': 'ingestion',
  'upload-pdf': 'ingestion',
  'url-download': 'ingestion',
  'cloud-transfer': 'ingestion',
  'sql-import': 'ingestion',
  'file-picker': 'ingestion',
  'auto-process': 'processing',
  'filter': 'analysis',
  'sheets': 'analysis',
  'search': 'analysis',
  'query': 'analysis',
  'chat': 'analysis',
  'visualize': 'visualization',
  'export': 'output',
  'api-endpoint': 'output',
  'mcp': 'output',
  'zapier': 'output',
};
